import { ContentTitle, PageTitle, SectionTitle, Subtitle, Title } from '../../components/typography/Heading';
import MaxWidthWrapper from '../../components/max-width-wrapper/MaxWidthWrapper';
import styles from './CMStitle.module.less';

const CMSTitle = ({ styling = 'section-title', text = '', headingLevel }) => {
    const title = {
        'page-title': PageTitle,
        'content-title': ContentTitle,
        'section-title': SectionTitle,
        'title-title': Title,
        'subtitle-title': Subtitle,
    };

    const TitleComponent = title[styling ?? SectionTitle];

    return (
        <MaxWidthWrapper className={styles.wrapper}>
            <TitleComponent tag={headingLevel} className={styles.title}>
                {text}
            </TitleComponent>
        </MaxWidthWrapper>
    );
};

export default CMSTitle;
